export default __webpack_public_path__ + "static/media/X.3b56a1df.png";